export const OPENED_ENTITY_ID_PARAM_NAME = 'openedEntityId';
